// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__httnC","footer":"styles_footer__31NWc"};